// removed by extract-text-webpack-plugin
module.exports = {"container":"_1nFf96VpCSWmmqfPaoyy3V","pending":"_1Kqt3szs56VYv2YX29l7NK","default":"_3LIXCOc9VSrfdldIiC4cdT","in_progress":"_2zFasTUkvjZalP3l7SRTIS","on_hold":"_25Gw83AfCndqAA6B8low1i","cancelled":"_2A5KH0e2JoRlhJmL0IY8HN","completed":"_20myAmY-WUDhqRSFPQyMUY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/lotStatusIcon/styles.css
// module id = 1627
// module chunks = 0